import React from 'react';
import { MixpanelProvider } from './MixpanelProvider';
import { useMixpanelUser } from '../hooks/useMixpanelUser';

interface MixpanelProviderWrapperProps {
  children: React.ReactNode;
}

export const MixpanelProviderWrapper: React.FC<MixpanelProviderWrapperProps> = ({ children }) => {
  const { userId, userProperties } = useMixpanelUser();
  
  return (
    <MixpanelProvider 
      userId={userId}
      userProperties={userProperties}
      trackPageViews={true}
      trackErrors={true}
    >
      {children}
    </MixpanelProvider>
  );
};
